import { TransactionFieldConfigStyles as AiTransactionFieldConfigStyles } from './ai/TransactionFieldConfig';
import { TransactionFieldConfigStyles as DrcTransactionFieldConfigStyles } from './cd/TransactionFieldConfig';
import { TransactionFieldConfigStyles as GyTransactionFieldConfigStyles } from './gy/TransactionFieldConfig';
import { TransactionFieldConfigStyles as BbTransactionFieldConfigStyles } from './bb/TransactionFieldConfig';
import { TransactionFieldConfigStyles as NaTransactionFieldConfigStyles } from './na/TransactionFieldConfig';
import { TransactionFieldConfigStyles as ZmTransactionFieldConfigStyles } from './zm/TransactionFieldConfig';
import { isCountry } from '../../modules/User/utils';

const CountryFieldSet = () => {
  return (
    <>
      {isCountry('AI') && <AiTransactionFieldConfigStyles />}
      {isCountry('CD') && <DrcTransactionFieldConfigStyles />}
      {isCountry('GY') && <GyTransactionFieldConfigStyles />}
      {isCountry('BB') && <BbTransactionFieldConfigStyles />}
      {isCountry('NA') && <NaTransactionFieldConfigStyles />}
      {isCountry('ZM') && <ZmTransactionFieldConfigStyles />}
    </>
  );
};

export default CountryFieldSet;
